module.exports = __webpack_public_path__ + "static/media/back4.c5ccfd6a.png";